import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Вокруг смыкается во тьме кольцо столетья,<br/>
        Удушен, ослеплён, готов я изнемочь.<br/>
        Ведь непоколебимо плотна ночь,<br/>
        Не разорву её глухую сеть я.
      </p>
      
      <p class="poem-block mb-3">
        И рот залеплен, и не в силах петь я,<br/>
        И нет того, кто мог бы мне помочь,<br/>
        И я, как птица пленная точь-в-точь,<br/>
        Бьюсь и боюсь, что не смогу успеть я.
      </p>
      
      <p class="poem-block mb-3">
        Но сброшен страха тошнотворный груз.<br/>
        Ко мне уже пришёл козырный туз<br/>
        И я смеюсь над прошлыми бедами.<br/>
        Над вымыслом слезами обольюсь<br/>
        И помощи высокочтимых Муз<br/>
        Добьюсь обильно-звонкими слезами.
      </p>
    </div>
    `
  )
}

const itemDate = {
  rus: 'Декабрь 2008 г'
}

const itemName = {
  rus: 'Сонет'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemDate: itemDate.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;